// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-2epeE";
var _4 = "wrapper_withText-2S5pd";
var _5 = "topWrapper-1lNQn";
var _6 = "icon_container-KX5Az";
var _7 = "center_icon-1OBFU";
var _8 = "icon_fail-kM82Z";
var _9 = "icon_success-1TW8W";
var _a = "header-1AiDM";
var _b = "success-2DDSg";
var _c = "failed-1xxQ5";
var _d = "icons-1Ki-s";
var _e = "paymentDots-v1_nd";
var _f = "content-mKWme";
var _10 = "textWrapper-5mkjw";
var _11 = "title-2F4zh";
var _12 = "text-3VBrU";
var _13 = "buttons-3wxGj";
var _14 = "redirectButton-2b_uK";
var _15 = "wrapper_withBanner-2tipw";
var _16 = "redirectButton_success-3HL96";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "wrapper_withText", _5 as "topWrapper", _6 as "icon_container", _7 as "center_icon", _8 as "icon_fail", _9 as "icon_success", _a as "header", _b as "success", _c as "failed", _d as "icons", _e as "paymentDots", _f as "content", _10 as "textWrapper", _11 as "title", _12 as "text", _13 as "buttons", _14 as "redirectButton", _15 as "wrapper_withBanner", _16 as "redirectButton_success" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "wrapper_withText": _4, "topWrapper": _5, "icon_container": _6, "center_icon": _7, "icon_fail": _8, "icon_success": _9, "header": _a, "success": _b, "failed": _c, "icons": _d, "paymentDots": _e, "content": _f, "textWrapper": _10, "title": _11, "text": _12, "buttons": _13, "redirectButton": _14, "wrapper_withBanner": _15, "redirectButton_success": _16 }
